// extracted by mini-css-extract-plugin
export default {"shortcut":"shortcut_shortcut__L7t7j","shortcutIcon":"shortcut_shortcutIcon__dn58a","shortcutText":"shortcut_shortcutText__-di39"};